import { useCallback, useFeatures } from 'sb-hooks'
import actions from 'redux/actions'
import { constants } from 'common/helpers'
import { processVindiciaRefund } from 'compositions/modals/cancelSubscription/util'

import {
  openSkipAMonthSuccessModal,
  openSkipAMonthRefundModal,
  closeSkipAMonthRefundModal,
} from 'compositions/modals/skipAMonth'

import useSkipAMonthModalBase from './useSkipAMonthModalBase'
import type { UseSkipAMonthModalProps } from './useSkipAMonthModalBase'


const useSkipAMonthModalVindicia = (props: UseSkipAMonthModalProps) => {
  const { closeModal } = props

  const { [constants.features.billingDay1stDayOfTheMonth]: isBillingDay1stEnabled } = useFeatures()

  const baseProps = useSkipAMonthModalBase(props)
  const { form } = baseProps

  const handleConfirm = useCallback(async () => {
    try {
      const { monthCount, remind } = await form.submit()

      actions.models.ui.showRequestLoader()

      const { refund, holdId } = await actions.models.subscription.skip({
        monthCount,
        remind,
      })

      actions.models.ui.hideRequestLoader()

      closeModal()

      if (refund) {
        const decision = await openSkipAMonthRefundModal()
        const { type, transactionType } = refund

        await processVindiciaRefund({ decision, type, transactionType, isBillingDay1stEnabled })

        closeSkipAMonthRefundModal()
      }

      openSkipAMonthSuccessModal({
        skippedMonthCount: monthCount,
        holdId,
      })
    }
    catch (error) {
      console.error(error)
      actions.models.ui.hideRequestLoader()
    }
  }, [ closeModal, form, isBillingDay1stEnabled ])

  return {
    ...baseProps,
    onConfirm: handleConfirm,
  }
}


export default useSkipAMonthModalVindicia
